import React, { useState } from 'react'
import HeaderBar from '../../Components/UI/headerbar'
import { useQuery } from 'react-query'
import { getExports } from '../../MyApi/downlaods'
import FilterBar from '../../Components/UI/filterbar'
import SingleDocument from '../../Components/downloads'
import PaginationComponent from '../../Components/UI/pagnationComponent'
import LoadingSpinner from '../../Components/UI/spinner'
import { Spinner } from 'react-bootstrap'

const DownloadsPage = () => {
    const [filters, setFilters] = useState({})
    const [currentPage, setCurrentPage] = useState(1)
    const {data ,isLoading} =useQuery(["getExports", currentPage, filters], ()=> getExports(currentPage, filters))
     const exports = data?.data?.exports || []   
     const totalPages = data?.data?.pagination.total
     const last_page= data?.data?.pagination.last_page
          console.log('exports', exports)
     const filtersConfig = { date:true}

  return (
    <div className='container-fluid'>       
        <HeaderBar title={"التنزيلات"} content={"إدارة ملفاتك وتقاريرك المصدرة"} isBack={true}/>
        <FilterBar  filtersConfig={filtersConfig} filters={filters} setFilters={setFilters}/>   
        <div className="row">
         {isLoading ? <LoadingSpinner/>: exports.map((exportItem) => (
            <SingleDocument key={exportItem.id} exportItem={exportItem} />
         ))}

         <PaginationComponent totalItems={totalPages} itemsPerPage={last_page} currentPage={currentPage} setCurrentPage={setCurrentPage} />
        </div>
    </div>
  )
}

export default DownloadsPage